<template>
  <form>
    <div>
      <AutoComplete
        id="select-user"
        :update="(value) => autoCompleteUpdate(value)"
        :suggestions="autoCompleteSuggestions"
        :item-selected="(value) => updateSelectedUser({ path: 'selected', value })"
        :value="value"
        :clear-on-selection="false"
        label="Select User"
      />
      <label v-if="selectedUser.email"
        >Set permissions for:
        <p className="small-size">{{ selectedUser.email }}</p></label
      >
    </div>

    <p>Hide:</p>
    <label v-for="permission in permissionsList" :key="permission.name">
      <checkbox
        :checked="permission?.checkedByDefault"
        :readonly="permission?.disabled"
        :update="
          (checked) =>
            updatePermission({
              path: `permissions.new.${permission.name}`,
              value: checked,
            })
        "
      />
      <span :class="{ 'readonly-label': permission?.disabled }">{{ permission.label }}</span>
    </label>
    <button
      v-if="registerLink === false"
      class="success"
      @click.prevent="
        () =>
          createPermissions({
            id,
            userId: selectedUser.id,
            email: selectedUser.email,
            permissions: checkablePermissions.new,
          })
      "
    >
      Create Permissions
    </button>
    <button
      v-else
      class="success"
      @click.prevent="
        () =>
          createRegisterLink({
            id,
            email: selectedUser.email,
            permissions: checkablePermissions.new,
          })
      "
    >
      Create Register Link
    </button>
  </form>
</template>
<script setup>
import AutoComplete from './AutoComplete.vue'
import Checkbox from './Checkbox.vue'
defineProps({
  autoCompleteUpdate: {
    type: Function,
    required: true,
  },
  autoCompleteSuggestions: {
    type: Array,
    required: true,
  },
  updateSelectedUser: {
    type: Function,
    required: true,
  },
  value: {
    type: String,
    required: true,
  },
  id: {
    type: String,
    required: true,
  },
  userEmail: {
    type: String,
    required: true,
  },
  selectedUser: {
    type: Object,
    required: true,
  },
  registerLink: {
    type: Boolean,
    required: true,
  },
  updatePermission: {
    type: Function,
    required: true,
  },
  createPermissions: {
    type: Function,
    required: true,
  },
  createRegisterLink: {
    type: Function,
    required: true,
  },
  permissionsList: {
    type: Array,
    required: true,
  },
  checkablePermissions: {
    type: Object,
    required: true,
  },
})
</script>

<style scoped>
.readonly-label {
  opacity: 0.5;
  pointer-events: none;
}
</style>
